/* ============================================================
   LW24 Shipping-Hint Override
   ------------------------------------------------------------
   Überschreibt den Text von #lw-shipping-hint auf Lampen-Logik:
   - 0 Lampen: "zzgl. 4,90 € · Noch 2 Lampen bis gratis Versand"
   - 1 Lampe:  "zzgl. 4,90 € · Noch 1 Lampe bis gratis Versand"
   - 2+ Lampen: "Gratis Versand mit DHL freigeschaltet"

   Robust gegen das bestehende Theme-Script via MutationObserver +
   Fetch-Patch (horcht auf cart:refresh Events vom drawer-progress.js).
   ============================================================ */
(function () {
  'use strict';

  var TARGET_LAMPS = 2; // Freischalt-Schwelle
  var ADDON_RE = /\b(aufpreis|zuschlag|upgrade|surcharge|add[\s-]?on|gebühr|versand)\b/i;

  // SVG-Icons (brand-konform, amber-dark / green)
  var TRUCK_ICON = '<svg class="lw-sh__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>';
  var CHECK_ICON = '<svg class="lw-sh__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  function isAddonItem(item) {
    if (!item) return false;
    if (item.properties && (item.properties._bundle_addon === 'true' || item.properties._addon === 'true')) return true;
    var title = (item.product_title || item.title || '') + ' ' +
                (item.variant_title || '') + ' ' +
                (item.product_type || '');
    return ADDON_RE.test(title);
  }

  function countLamps(cart) {
    if (!cart || !cart.items) return 0;
    var qty = 0;
    cart.items.forEach(function (it) {
      if (!isAddonItem(it)) qty += it.quantity || 0;
    });
    return qty;
  }

  function buildHtml(qty) {
    if (qty >= TARGET_LAMPS) {
      return '<span class="lw-sh lw-sh--free">' +
               CHECK_ICON +
               '<span class="lw-sh__text">Gratis Versand mit DHL freigeschaltet</span>' +
             '</span>';
    }
    var remaining = TARGET_LAMPS - qty;
    var lampWord = remaining === 1 ? 'Lampe' : 'Lampen';
    return '<span class="lw-sh lw-sh--pending">' +
             TRUCK_ICON +
             '<span class="lw-sh__text">' +
               '<span class="lw-sh__fee">zzgl. 4,90 € Versand</span>' +
               '<span class="lw-sh__sep" aria-hidden="true">·</span>' +
               '<strong class="lw-sh__remaining">Noch ' + remaining + ' ' + lampWord + ' bis gratis Versand</strong>' +
             '</span>' +
           '</span>';
  }

  var lastRendered = null;
  function apply(qty) {
    var el = document.getElementById('lw-shipping-hint');
    if (!el) return;
    var html = buildHtml(qty);
    if (el.innerHTML !== html) {
      el.innerHTML = html;
      lastRendered = html;
    }
  }

  var cachedQty = 0;
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cachedQty = countLamps(cart);
        apply(cachedQty);
      })
      .catch(function () { apply(cachedQty); });
  }

  function reapply() {
    apply(cachedQty);
  }

  var debounceTimer = null;
  function refreshDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 80);
  }

  function boot() {
    var el = document.getElementById('lw-shipping-hint');
    if (!el) return;

    refresh();

    // Cart-Events (lw-bundle-drawer-progress.js feuert cart:refresh)
    document.addEventListener('cart:refresh', refreshDebounced);
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshDebounced);
    }

    // MutationObserver: wenn existing Theme-Script den Text überschreibt → re-apply
    try {
      var mo = new MutationObserver(function () {
        var el = document.getElementById('lw-shipping-hint');
        if (!el || !lastRendered) return;
        if (el.innerHTML !== lastRendered) {
          clearTimeout(window.__lwShReapply);
          window.__lwShReapply = setTimeout(reapply, 50);
        }
      });
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();